import Movimentacao from "@/Pages/Caixas/movimentacao.vue";

export default [
  {
    path: "/movimentacoes",
    name: "movimentacao",
    component: Movimentacao,
  },
];
